'use strict';

bbw.directive.bbwScrollWatch = ['$rootScope', '$document', 'bbw.OffsetCalcSvc', '$timeout', function($rootScope, $document, offsetCalcSvc, $timeout) {

    var ScrollWatchElement = Class({
        construct: function(element, idAttr) {
            this.element = element;
            this.id = element.getAttribute(idAttr);
            this.calc();
        },
        calc: function() {
            this.top = offsetCalcSvc.top(this.element);
        }
    });

    var getScrollTop = function() {
        return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
    };

    return {
        link: function(scope, element, attrs) {
            var scopeVar = attrs.bbwScrollWatch;
            var watchAttrName = attrs.bbwScrollWatchAttr || 'scroll-id';
            var debounceTime = attrs.bbwScrollWatchDebounce || 500;
            var elements = [];
            var debounceTimeout = undefined;
            var topmostElement = undefined;
            var findTopmostElement = function() {
                if (!elements.length) {
                    return undefined;
                }
                var scrollTop = getScrollTop();
                var el = undefined;
                for (var i = 0; i < elements.length; ++i) {
                    if (elements[i].top <= scrollTop) {
                        el = elements[i];
                    }
                }
                return el;
            };
            var findElementById = function(id) {
                for (var i = 0; i < elements.length; ++i) {
                    if (elements[i].id == id) {
                        return elements[i];
                    }
                }
            };
            var scrollToElementById = function(id) {
                updateElements();
                var scrollToElement;
                if (angular.isString(id) && id !== '') {
                    if (topmostElement && topmostElement.id == id) {
                        return;
                    }
                    scrollToElement = findElementById(id);
                } else {
                    if (angular.isUndefined(topmostElement)) {
                        return;
                    }
                }
                topmostElement = scrollToElement;
                window.scrollTo(0, scrollToElement ? scrollToElement.top : 0);
                return scrollToElement;
            };
            var setTopmostElement = function(element) {
                if (topmostElement !== element) {
                    topmostElement = element;
                    if (scopeVar) {
                        var cb = function() {
                            ngtk.tools.object.assignByPath(scope, scopeVar, topmostElement ? topmostElement.id : undefined);
                        };
                        if ($rootScope.$$phase) {
                            scope.$evalAsync(cb);
                        } else {
                            scope.$apply(cb);
                        }
                    }
                }
            };
            var updateTopmostElement = function() {
                setTopmostElement(findTopmostElement());
            };
            var updateElements = function() {
                elements = Array.prototype.reduce.call(
                    element[0].querySelectorAll('[' + watchAttrName + ']'),
                    function(carry, element) {
                        return carry.push(new ScrollWatchElement(element, watchAttrName)), carry;
                    },
                    []
                );
                elements.sort(function(a, b) {
                    return a.top - b.top;
                });
            };
            var cancelTimeout = function() {
                if (debounceTimeout) {
                    $timeout.cancel(debounceTimeout);
                    debounceTimeout = undefined;
                }
            };
            var onScroll = function() {
                cancelTimeout();
                debounceTimeout = $timeout(function() {
                    updateElements();
                    updateTopmostElement();
                }, debounceTime);
            };
            var listening = false;
            var init = function() {
                updateElements();
                scrollToElementById(scope.$eval(scopeVar));
                window.addEventListener('scroll', onScroll);
                listening = true;
            };
            var destroy = function() {
                if (listening) {
                    listening = false;
                    window.removeEventListener('scroll', onScroll);
                }
            };
            setTimeout(function() {
                init();
                scope.$on('$destroy', destroy);
                element.on('$destroy', destroy);
            }, 100);
        }
    }

}];
